module.exports = __webpack_public_path__ + "img/c4.59dfc07a.png";